import type { WebhooksHostProps } from 'shared/webhooks';
import { useClientData } from '@/providers/ClientData.provider';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

export default function useWebhooksHostProps(): WebhooksHostProps {
  const { response } = useClientData();
  const { userSettings } = useUserSettingsProvider();

  return {
    basePath: '/settings/webhooks',
    viewer: { username: response.LoginUserName, timezone: userSettings.timezone },
  };
}
